import { configureStore } from '@reduxjs/toolkit';
import LanguageSlice from './reducers/LanguageSlice';


export default configureStore({
  reducer: {
   language:LanguageSlice
  },
});